import { render, staticRenderFns } from "./app-sendOrders.vue?vue&type=template&id=31f42418"
import script from "./app-sendOrders.vue?vue&type=script&lang=js"
export * from "./app-sendOrders.vue?vue&type=script&lang=js"
import style0 from "./app-sendOrders.vue?vue&type=style&index=0&id=31f42418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports